import { BankAccount } from 'types/bankAccountTypes';

export const createBankAccount = (id: string): BankAccount => ({
  unp: '',
  name: '',
});

export const createBankAccountMock = (): BankAccount => ({
  unp: '101541947',
  name: 'ЗАО "АЛЬФА-БАНК"',
});
